import { getLabelAndInputRow } from '../../Form/Form';
import { InputType } from '../../Form/InputType';

export const getInitialFormValuesById = (user, organization) => {
	const initialFormValuesById = {
		firstName: user.firstName,
		lastName: user.lastName,
		account: organization && organization.displayName,
		title: user.title,
		phone: user.phone,
		email: user.email,
		password: '••••••••••',
	};

	return initialFormValuesById;
};

export const getRowOptionsList = () => {
	const rowOptionsList = [
		getLabelAndInputRow('First Name', 'firstName', true),
		getLabelAndInputRow('Last Name', 'lastName', true),
		getLabelAndInputRow('Title', 'title'),
		getLabelAndInputRow('Phone', 'phone'),
		getLabelAndInputRow('Email', 'email', false, InputType.UneditableInput),
		getLabelAndInputRow(
			'Password',
			'password',
			false,
			InputType.UneditableInput,
		),
	];

	return rowOptionsList;
};
